import { v4 as uuidv4 } from 'uuid';

export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('vi-VN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return 'Invalid Date';
  }
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getExtension = (name: string) => {
  const extension = name?.split('.')?.[name.split('.').length - 1]?.toLowerCase() ?? '';
  return extension === '' ? 'folder' : extension;
};

export const getTotalFilesCount = (folder: any): number => {
  let count = folder.documents?.length || 0;
  if (folder.subFolders) {
    folder.subFolders.forEach((subfolder: any) => {
      count += getTotalFilesCount(subfolder);
    });
  }
  return count;
};

// Removed transformFile2Base64 - use readFileAsBase64 in useFileUpload hook instead

export const generateUniqueId = (): string => {
  return uuidv4();
};
